import { Box, LinearProgress } from '@mui/material'
import NProgress from 'nprogress'
import { useEffect } from 'react'

function LoadingScreen() {
  useEffect(() => {
    NProgress.start()

    return () => {
      NProgress.done()
    }
  }, [])

  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: ({ palette }) => palette.background.default,
        display: 'flex',
        flexDirection: 'column',
        height: '80vh',
        justifyContent: 'center',
        minHeight: '100%',
        padding: 3,
      }}>
      <Box width={400}>
        <LinearProgress />
      </Box>
    </Box>
  )
}

export default LoadingScreen
